import styled from '@emotion/styled'
import { calcRem, metrics } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'
import { HorizontalDividerProps } from './HorizontalDivider'

export const StyledHorizontalDivider = styled('hr')<HorizontalDividerProps>(
    ({ verticalGutters, verticalSpacing }) => [
        {
            border: 0,
            borderTop: '1px solid ',
            borderColor:
                tokens.thenightly.colors.palette.neutral[20],
            width: '100%',
            margin: '0 auto',

            marginBottom:
                verticalSpacing &&
                calcRem(metrics.thenightly.margins[verticalSpacing]),
            marginTop:
                verticalSpacing &&
                calcRem(metrics.thenightly.margins[verticalSpacing]),
            paddingTop:
                verticalGutters &&
                calcRem(metrics.thenightly.margins[verticalGutters[0]]),
            paddingBottom:
                verticalGutters &&
                calcRem(metrics.thenightly.margins[verticalGutters[1]]),
        },
    ],
)
